"use client";

import useBreakpoint from "@/hooks/useBreakpoints";
import Product from "../product";
import { Button } from "../ui/button";
import { useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import ProductCard from "../product/ProductCard";
import useCart from "@/app/hooks/useCart";
import Animate from "../Animate";

export default function ProductSlider({ productList = [] }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [pagination, setPagination] = useState(0);
  const [noOfSlide, setNoOfSlide] = useState(5);
  const [gap, setGap] = useState("1rem");
  const breakpoints = useBreakpoint();
  const splide = useRef();
  const elementLength = productList?.length || 0;

  const { addCartItem } = useCart();

  useEffect(() => {
    if (breakpoints === "lg" || breakpoints === "xl") {
      setNoOfSlide(5);
      setGap("1rem");
      setPagination(Math.floor(elementLength / 5));
    } else if (breakpoints === "md") {
      setNoOfSlide(4);
      setGap("14px");
      setPagination(Math.floor(elementLength / 3));
    } else if (breakpoints === "sm" || breakpoints === "xs") {
      setNoOfSlide(2);
      setGap("12px");
      setPagination(Math.floor(elementLength / 2));
    }
  }, [breakpoints]);

  const nextButton = () => {
    setActiveIndex(activeIndex + 1);
    splide.current.go((activeIndex + 1) * noOfSlide);
  };
  const prevButton = () => {
    setActiveIndex(activeIndex - 1);
    splide.current.go((activeIndex - 1) * noOfSlide);
  };

  useEffect(() => {
    if (splide.current) {
      splide.current.splide.on("moved", newIndex => {
        if (breakpoints === "lg" || breakpoints === "xl") {
          setActiveIndex(parseInt(newIndex / 5));
        } else if (breakpoints === "md") {
          setActiveIndex(parseInt(newIndex / 3));
        } else if (breakpoints === "sm" || breakpoints === "xs") {
          setActiveIndex(parseInt(newIndex / 2));
        }

        // You can perform any action here when the slide changes
      });
    }
  }, [breakpoints]);

  const handleScrollBarClick = index => {
    if (splide.current) {
      splide.current.splide.go(index * noOfSlide);
    }
  };

  return (
    <>
      <div>
        <Splide
          ref={splide}
          options={{
            perPage: noOfSlide,
            pagination: false,
            gap: gap,
            arrows: false,
          }}
        >
          {productList.length > 0 &&
            productList.map((product, index) => (
              <SplideSlide key={product.id}>
                <Animate delay={`${index === 0 ? 1 : (index % 5) * 0.3}`}>
                  <div className="w-full my-2">
                    <ProductCard product={product} handleAddCart={addCartItem} />
                  </div>
                </Animate>
              </SplideSlide>
            ))}
        </Splide>

        <div className="flex items-center mt-6">
          <div className="flex">
            <Button
              disabled={activeIndex === 0}
              variant="icon"
              className="!w-[32px] !h-[32px] !lg:w-[30px] !lg:h-[30px] border"
              onClick={prevButton}
            >
              <ChevronLeft className="h-[20px] w-[20px] text-midnightIndigo-400" />
            </Button>
            <Button
              variant="icon"
              className="!w-[32px] !h-[32px] !lg:w-[30px] !lg:h-[30px] border ml-2"
              onClick={nextButton}
              disabled={activeIndex === pagination - 1}
            >
              <ChevronRight className="h-[20px] w-[20px] hoverunderline" />
            </Button>
          </div>

          <div className="flex w-full ml-4 bg-midnightIndigo-200 rounded overflow-hidden">
            {Array.from({ length: pagination }).map((_, index) => (
              <div
                onClick={() => handleScrollBarClick(index)}
                key={index}
                className={`h-[1.78px] 
                cursor-pointer
                rounded
                ${activeIndex === index && "bg-midnightIndigo-400"} w-full flex-grow`}
              ></div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
